export default __webpack_public_path__ + "static/media/matheusteles.26fd007c.jpeg";